import type { FunctionComponent } from 'react';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { ROSTER_ROUTES, ROUTES } from '../../../util/vars';
import NavLink from './Nav.styled';
import { useCleverIntegration } from '../../../hooks/useCleverIntegration';
import { useIdentity } from '@whizz/react-identity';

const Nav: FunctionComponent = () => {
  const { me } = useIdentity();
  const { translate } = useI18n();
  const [ isClever ] = useCleverIntegration();
  const localeId = (me as Teacher).locale?.id;
  const showParentsSection = [ 'en-gb', 'en-us', 'en-nz', 'en-ke', 'en-ae', 'sw-ke', 'es-mx' ].includes(localeId);

  return (
    <div className={'flex items-center justify-evenly bg-white shadow py-4'}>
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.student}`}
        icon={'StudentChart'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.STUDENTS')}
        size={80}
        data-cy={'rm-nav-students'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.staff}`}
        icon={'Student'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.STAFF')}
        data-cy={'rm-nav-staff'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.class}`}
        icon={'Classes'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.CLASSES')}
        data-cy={'rm-nav-classes'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.tags}`}
        icon={'Label'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.TAGS')}
        data-cy={'rm-nav-tags'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.upload2}`}
        icon="Megaphone"
        label={translate('pages.ROSTER_MANAGEMENT.NAV.UPLOAD')}
        data-cy={'rm-nav-upload'}
        disabled={isClever}
        showIconOnDesktop ={true}
        iconInline ={true}
      />
      { showParentsSection ? <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.parents}`}
        icon={'Wc'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.PARENTS')}
        data-cy={'rm-nav-parents'}
      /> : null }
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.tidy}`}
        icon={'DeleteForever'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.TIDY')}
        data-cy={'rm-nav-tidy'}
        disabled={isClever}
      />
    </div>
  );
};

export default Nav;
